<script>
import ky from "ky";
import emailValidator from "email-validator";

export default {
  name: "RequestForm",
  data() {
    return {
      loading: 0,
      fields: {
        name: "",
        phone: "",
        email: "",
        message: "",
      },
      errors: {
        name: false,
        phone: false,
        email: false,
      },
    };
  },
  methods: {
    validate() {
      let error = false;

      this.errors = {
        name: false,
        phone: false,
        email: false,
      };

      if (!this.fields.name) {
        if (!error) {
          this.$refs.name.focus();
        }

        this.errors.name = true;
        error = true;
      }

      if (
        !this.fields.phone ||
        this.fields.phone.replace(/\D/g, "").length != 11
      ) {
        if (!error) {
          this.$refs.phone.focus();
        }

        this.errors.phone = true;
        error = true;
      }

      if (this.fields.email && !emailValidator.validate(this.fields.email)) {
        if (!error) {
          this.$refs.email.focus();
        }

        this.errors.email = true;
        error = true;
      }

      return !error;
    },
    async submit() {
      if (!this.validate()) {
        return;
      }

      const data = Object.assign({}, window.Application.config, {
        data: { form: this.fields },
      });

      this.loading++;

      const json = await ky
        .post("/ajax/forms/submit_request.php", { json: data })
        .json();
      
      this.loading--;

      if (json.result && json.result == "success") {
        this.$root.openDialog(this.$v("MSG_FORM_REQUEST_SUCCESS"), {
          html: true,
          buttons: [],
          close: true,
        });
        this.fields = {
          name: "",
          phone: "",
          email: "",
          message: ""
        };

        this.$emit("done");
      } else if (json.error) {
        this.$root.openDialog(json.error, { buttons: [], close: true });
      } else {
        this.$root.openDialog(this.$v("MSG_FORM_REQUEST_ERROR"), {
          html: true,
          buttons: [],
          close: true,
        });
      }
    },
  },
};
</script>

<template>
  <div class="block-form">
    <div class="left">
      <slot />
    </div>
    <div class="right">
      <div class="loading" v-if="loading > 0"></div>
      <div class="row">
        <text-field
          :label="$v('STR_NAME')"
          v-model="fields.name"
          :error="errors.name"
          ref="name"
          asterisk
        />
      </div>
      <div class="row">
        <text-field
          :label="$v('STR_PHONE')"
          v-model="fields.phone"
          :error="errors.phone"
          ref="phone"
          mask="+7 (999) 999-99-99"
          asterisk
        />
      </div>
      <div class="row">
        <text-field
          :label="$v('STR_EMAIL')"
          v-model="fields.email"
          :error="errors.email"
          type="email"
          ref="email"
          email-chars
        />
      </div>
      <div class="row">
        <text-area
          :label="$v('STR_MESSAGE')"
          v-model="fields.message"
          ref="message"
          no-resize
        />
      </div>
      <div class="row button-row">
        <button class="submit-button" type="button" @click="submit">
          {{ $v("STR_SEND") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-form {
  &:not(.popup) {
    margin-bottom: 80px;
    background: #fff url(/images/form-background.svg) left 40px bottom 40px
      no-repeat;
    box-shadow: 5px 10px 30px rgba(43, 158, 204, 0.25);
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 900px;
    padding: 63px 70px 63px 70px;
    border-radius: 15px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;

    @media screen and (max-width: 800px) {
      display: block;
    }

    @media screen and (max-width: 600px) {
      padding: 25px;
      margin-bottom: 40px;
    }
    .form2 & {
      margin-top: 80px;
      background: #fff url(/images/form-background.svg) left 240px bottom 40px
        no-repeat;
    }
  }

  .left {
    max-width: 350px;
    padding-right: 20px;

    @media screen and (max-width: 800px) {
      max-width: none;
      padding-right: 0;
      padding-bottom: 30px;
    }
  }

  .right {
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 300px;

    @media screen and (max-width: 800px) {
      max-width: none;
    }
  }

  .loading {
    &::before,
    &::after {
      content: "";
      display: block;
      position: absolute;
      z-index: 80;
    }

    &::before {
      left: -5px;
      right: -5px;
      top: -5px;
      bottom: -5px;
      background: rgba(#ffffff, 0.75);
    }

    &::after {
      left: 50%;
      top: 50%;
      width: 50px;
      height: 50px;
      box-sizing: border-box;
      margin: -25px;
      border: 4px solid $color-brand-1;
      border-left: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-radius: 50%;
      animation: loading-spin 1s infinite linear;
    }

    @keyframes loading-spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  }

  .row {
    margin-bottom: 10px;

    &.button-row {
      padding-top: 10px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .button-row {
    padding-top: 20px;
  }

  .submit-button {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 0 40px 0 40px;
    border: none;
    background: $color-brand-1;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 5px;
    width: 100%;

    &:hover {
      background: $color-brand-2;
    }
  }

  &.popup {
    .submit-button {
      width: auto;
      margin-left: auto;
      margin-right: auto;
      font-size: 18px;
      padding: 0 20px 0 20px;
    }
  }
}
</style>

<style lang="scss">
.block-form {
    .block-title {
        display: inline-block;
        vertical-align: top;
        padding-bottom: 25px;
        border-bottom: 3px solid $color-brand-1;
        margin-bottom: 35px;

        @media screen and (max-width: 800px) {
          padding-bottom: 15px;
          margin-bottom: 15px;
        }
    }

    .block-description {
        color: $color-dark;

        small {
          display: block;
          color: $color-dark;
        }
    }
}
</style>